import axios from "axios"

import { Toast } from 'vant';

import _this from "@/main";

const ROOT_PATH = ""
// const ROOT_PATH = "https://sdk.weiyiltd.xyz"
// const ROOT_PATH = "https://sdk.gopayug.com"
// const ROOT_PATH = "https://sdk.rwazapay.com"
// const ROOT_PATH = "https://sdk.mkopotz.com"
// const ROOT_PATH = "https://sdk.paiementsl.com"
// const ROOT_PATH = "https://sdk.thaionepay.com"
// const ROOT_PATH = "https://sdk.paiementtd.com"
// const ROOT_PATH = "https://sdk.birrpayet.com"
// const ROOT_PATH = "https://sdk.mfoupaycm.com"
// const ROOT_PATH = "https://sdk.gopaybd.com"
// const ROOT_PATH = "https://sdk.mfoupaycm.com"
// const ROOT_PATH = "https://sdk.mfoupaycm.com"
// const ROOT_PATH = "https://ghsdk.ngwepay.com"
// const ROOT_PATH = "https://sdk.nepaiement.com"
// const ROOT_PATH = "https://ngsdk.ngwepay.com"
// const ROOT_PATH = "https://sdk.paiementmz.com"
// const ROOT_PATH = "https://sdk.paiementao.com"

const http = axios.create({
  baseURL: ROOT_PATH,
  timeout: 300000
})
const SUCCESS_CODE = "200"
let requestCount = 0; // 计数器

http.defaults.headers.post["Content-Type"] = "application/json;charset=UTF-8"
http.defaults.headers.delete["Content-Type"] = "application/json;charset=UTF-8"
http.defaults.headers.put["Content-Type"] = "application/json;charset=UTF-8"
http.defaults.transformRequest = [
  function(data) {
    if (Object.prototype.toString.call(data) === "[object FormData]") {
      return data
    } else {
      return JSON.stringify(data)
    }
  }
]

http.interceptors.request.use(
  config => {
    if (!config.noFormatUndefined && config.params) {
      Object.keys(config.params).forEach(key => {
        if (config.params[key] === "") {
          config.params[key] = undefined
        }
      })
    }

    // 请求开始时增加计数
    requestCount++;
    if (requestCount === 1 && !config.hideLoading) {
      Toast.loading({
        message: _this.$t("text_loading"),
        duration: 0 // 持续显示
      });
    }

    return config
  },
  error => {
    return Promise.reject(error)
  }
)

http.interceptors.response.use(
  response => {
    const data = response.data
    
    // 请求结束时减少计数
    requestCount--;
    if (requestCount === 0) {
      Toast.clear(); // 清除加载状态
    }

    if (response.request.responseType === "blob") {
      return Promise.resolve(response)
    }
    if (data.code !== SUCCESS_CODE) {
      Toast(data.msg);
      // return Promise.reject(data)
      return Promise.resolve(data)
    } else {
      return Promise.resolve(data)
    }
  },
  error => {
    const errorRes = error.response
    
    // 请求结束时减少计数
    requestCount--;
    if (requestCount === 0) {
      Toast.clear(); // 清除加载状态
    }

    if (errorRes) {
      switch (errorRes.status) {
        case 401:
          console.error("登录已过期，请重新登录")
          break
        case 404:
          console.error("请求不存在")
          break
        default:
          console.error(errorRes.data.msg)
      }
    } else {
      if (error.message.includes("timeout")) {
        console.error("请求超时，请检查网络是否正常")
      } else {
        console.error("请求失败，请检查网络是否已连接")
      }
    }
    return Promise.reject(error)
  }
)

export default http